<div class="black">
  <div class="flex-end">
    <button mat-icon-button color="warn" (click)="closeDialog()">
      <mat-icon svgIcon="close-circle"></mat-icon>
    </button>
  </div>
  <div class="title margin-vertical-1 black">
    <div [outerHTML]="data.title | translate"></div>
  </div>

  <div class="flex-center" *ngIf="loading">
    <mat-spinner color="accent" diameter="50"></mat-spinner>
  </div>
  <app-booking-calendar
    (viewRange)="onChangeView($event)"
    [schedule]="schedule"
    (onEventClicked)="onEventClicked($event)"
    [loading]="loading"
  ></app-booking-calendar>

  <button
    *ngIf="!loading"
    mat-raised-button
    color="primary"
    class="width-50 margin-top-1 margin-bottom-2 padding-05 col-5"
    [disabled]="isDisabled"
    type="button"
    (click)="onReschedule()"
  >
    <span>{{ "reschedule" | translate }}</span>
  </button>
</div>
